import React from "react";
import "./Annotation.css";
import KeytermPopover from "../KeytermPopover/KeytermPopover";


const Annotation = ({ timeline, createElement, annotationPaneRef, frame }) => {

  const formatTooltip = (str) => {
    let parser = new DOMParser();
    let parents
    let htmlStr = str
    if (str) {
      if (str[0] !== "<" ||
        (str[str.length - 1] !== ">" && str[str.length - 2] !== ">")
      ) {
        htmlStr = `<div>${str}</div>`
        const doc = parser.parseFromString(htmlStr, 'text/html');
        parents = doc.body.getElementsByTagName('div')
      } else {
        const doc = parser.parseFromString(htmlStr, 'text/html');
        parents = doc.body.getElementsByTagName('p')
      }
    } else {
      const doc = parser.parseFromString(htmlStr, 'text/html');
      parents = doc.body.getElementsByTagName('p')
    }

    const parentArr = Array.from(parents)

    const formattedElements = parentArr.map(node => {
      return (
        Array.from(node.childNodes).map((child, childIndex) => {
          if (child.localName === "a") {
            return [<KeytermPopover
              title={child.innerHTML}
              description={child.title}
              annotationPaneRef={annotationPaneRef}
              key={childIndex}
            />]
          }
          else {
            return child
          }
        }))
    }
    )
    return formattedElements
  }

  return (
    <div className="annotation-paragraph-container">
      {/* <p>{frame ? frame.text : null}</p> */}
      {frame ? formatTooltip(frame.text).map((parent, parentIndex) => (
        <p key={parentIndex}>
          {parent.map((child, childIndex) => (
            Array.isArray(child) ? child
              :
              child.nodeName === "#text" ?
                <span key={childIndex}>{child.textContent}</span>
                :
                child.nodeName === "EM" || child.nodeName === "I" ?
                  <em key={childIndex}>{child.textContent}</em>
                  :
                  child.localName === "img" ?
                    createElement(child.localName, { "src": child.src, "className": child.className, "key": childIndex, "alt": child.alt })
                    :
                    createElement(child.localName, { "key": childIndex }, child.textContent ? child.textContent : null)
          ))}
        </p>
      )) : null}
    </div>
  )
}

export default Annotation